import { compose } from 'redux'
import { IResponseState } from '../../../components/Modals/ResponseModal/module/constants'
import { IAction } from '../../../models/Action'
import { immutableSet } from '../../../utils/immutable'
import { actionTypes } from './actions'
import emptyState from './emptyState'

import {
  CREATE_CERTIFICATION_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  perimeterObjectType,
  TAB_SELECTED_IDENTIFIER,
} from './constants'
import { IDENTITY_SYSTEM } from '../../../module/constants'
import {
  TechnicalUserDisplayedModel,
  TechnicalUserModel,
} from '../../../models/TechnicalUsers'

const {
  STEP_ONE,
  STEP_TWO,
  SUPERVISORS,
  ADDED_SUPERVISORS,
  STEP_THREE,
  REVISORS,
  REVISOR_SELECTED,
  ADDED_APPLICATIONS,
  ADDED_BR,
  ADDED_GROUPS,
  ADDED_USERS,
  APPLICATIONS,
  BR,
  DESCRIPTION,
  DURATION,
  GROUPS,
  NAME,
  OPERATION,
  SEQUENCE,
  START_DATE,
  STEP_EIGHT,
  STEP_FIVE,
  STEP_FOUR,
  STEP_SEVEN,
  STEP_SIX,
  TOLERANCE,
  TYPE,
  USERS,
  VALIDATION,
  ADDED_ENTITLEMENTS,
  ENTITLEMENTS,
  STEP_NINE,
  TECHNCIAL_USERS,
  ADDED_TECHNCIAL_USERS,
  STEP_TEN,
  CALL_STATE,
  CONFIRM_MODAL_TRIGGER,
  ENRICHMENT_SELECTED_CERTIFICATION,
  SELECTED_CERTIFICATION,
  ALREADY_SET,
} = CREATE_CERTIFICATION_IDENTIFIER

const ACTION_HANDLERS = {
  [actionTypes.SET_SELECTED_CERTIFICATION_FROM_CONSOLE_ADMIN_TO_CREATE_CAMPAIGN]:
    (state: any, action: any) =>
      immutableSet([SELECTED_CERTIFICATION], action.payload, state),
  [actionTypes.SET_SELECTED_CERTIFICATION_ENRICHMENT_FROM_CONSOLE_ADMIN_TO_CREATE_CAMPAIGN]:
    (state: any, action: any) => {
      let supervisorsToAdd: any = [...state.stepTwo.addedSupervisors]
      let ousToAdd: any = [...state.stepFive.addedGroups]
      let usersToAdd: any = [...state.stepSix.addedUsers]
      let applicationsToAdd: any = [...state.stepSeven.addedApplication]
      let brsToAdd: any = [...state.stepEight.addedBR]
      let entitlementsToAdd: any = [...state.stepNine.addedEntitlements]

      if (!state.alreadySet) {
        action.payload.supervisors?.forEach((fullSupervisor: any) => {
          if (
            supervisorsToAdd.filter(
              (supervisorToAdd: any) =>
                supervisorToAdd.id_user === fullSupervisor.id
            ).length === 0
          ) {
            let supervisorToAdd: any = {
              id_user: fullSupervisor.id,
              name: fullSupervisor.name,
              surname: fullSupervisor.surname,
              code: fullSupervisor.code,
              uidMaster: fullSupervisor.resp_code,
              organizational_unit: fullSupervisor.organizational_unit,
            }
            supervisorsToAdd.push(supervisorToAdd)
          }
        })

        action.payload.perimeter?.forEach((perimeterObject: any) => {
          switch (perimeterObject.type) {
            case perimeterObjectType.APPLICATION:
              if (
                applicationsToAdd.filter(
                  (applicationToAdd: any) =>
                    applicationToAdd.id === perimeterObject.application.id
                ).length === 0
              ) {
                let applicationToAdd: any = {
                  id: perimeterObject.application.id,
                  application_name: perimeterObject.application.name,
                  description: perimeterObject.application.description,
                  identitySystemId:
                    IDENTITY_SYSTEM[
                      perimeterObject.application
                        .identitySystemId as keyof typeof IDENTITY_SYSTEM
                    ],
                  include: perimeterObject.included,
                }
                applicationsToAdd.push(applicationToAdd)
              }
              break
            case perimeterObjectType.BR:
              if (
                brsToAdd.filter(
                  (brToAdd: any) =>
                    brToAdd.br_id ===
                    perimeterObject.businessRole.codeBusinessRole
                ).length === 0
              ) {
                let brEntitlementsToAdd: any = []
                perimeterObject.businessRole.entitlements.forEach(
                  (entitlement: any) => {
                    let toAdd: any = {
                      entitlementId: entitlement.entitlement_id,
                      identitySystemId:
                        IDENTITY_SYSTEM[
                          entitlement.identity_system_id as keyof typeof IDENTITY_SYSTEM
                        ],
                    }
                    brEntitlementsToAdd.push(toAdd)
                  }
                )
                let brToAdd: any = {
                  br_id: perimeterObject.businessRole.codeBusinessRole,
                  name: perimeterObject.businessRole.name,
                  description: perimeterObject.businessRole.description,
                  ouCode: perimeterObject.businessRole.ou,
                  isBR: true,
                  entitlements: brEntitlementsToAdd,
                  include: perimeterObject.included,
                }
                brsToAdd.push(brToAdd)
              }
              break
            case perimeterObjectType.ENTITLEMENT:
              if (
                entitlementsToAdd.filter(
                  (entitlementToAdd: any) =>
                    entitlementToAdd.entitlement_id ===
                    perimeterObject.entitlement.entitlement_id
                ).length === 0
              ) {
                let {
                  baoFullName,
                  violationOfVisibility,
                  involvedInSOD,
                  ...rest
                } = perimeterObject.entitlement
                let entitlementToAdd: any = {
                  ...rest,
                  include: perimeterObject.included,
                  identitySystemId:
                    IDENTITY_SYSTEM[
                      perimeterObject.identity_system_id as keyof typeof IDENTITY_SYSTEM
                    ],
                }
                entitlementsToAdd.push(entitlementToAdd)
              }
              break
            case perimeterObjectType.OU:
              if (
                ousToAdd.filter(
                  (ouToAdd: any) => ouToAdd.id === perimeterObject.ou.ou
                ).length === 0
              ) {
                let ouToAdd: any = {
                  id: perimeterObject.ou.ou,
                  name: perimeterObject.ou.name,
                  ownercode: perimeterObject.ou.ownercode,
                  identitySystemId:
                    IDENTITY_SYSTEM[
                      perimeterObject.ou
                        .identitySystemId as keyof typeof IDENTITY_SYSTEM
                    ],
                  include: perimeterObject.included,
                }
                ousToAdd.push(ouToAdd)
              }
              break
            case perimeterObjectType.USER:
              if (
                usersToAdd.filter(
                  (userToAdd: any) =>
                    userToAdd.id_user === perimeterObject.user.id
                ).length === 0
              ) {
                let userToAdd: any = {
                  id_user: perimeterObject.user.id,
                  name: perimeterObject.user.name,
                  surname: perimeterObject.user.surname,
                  uidMaster: perimeterObject.user.code,
                  organizational_unit: perimeterObject.user.organizational_unit,
                  include: perimeterObject.included,
                }
                usersToAdd.push(userToAdd)
              }
              break
          }
        })
      }

      return compose(
        immutableSet([ENRICHMENT_SELECTED_CERTIFICATION], action.payload),
        immutableSet([STEP_TWO, ADDED_SUPERVISORS], supervisorsToAdd),
        immutableSet([STEP_FIVE, ADDED_GROUPS], ousToAdd),
        immutableSet([STEP_SIX, ADDED_USERS], usersToAdd),
        immutableSet([STEP_SEVEN, ADDED_APPLICATIONS], applicationsToAdd),
        immutableSet([STEP_EIGHT, ADDED_BR], brsToAdd),
        immutableSet([STEP_NINE, ADDED_ENTITLEMENTS], entitlementsToAdd)
      )(state)
    },
  [actionTypes.SET_ALREADY_SET]: (state: any, action: any) =>
    immutableSet([ALREADY_SET], action.payload, state),
  [actionTypes.SET_CAMPAIGN_DETAIL]: (state: any, action: any) =>
    immutableSet([STEP_ONE], action.payload, state),
  [actionTypes.SET_CAMPAIGN_TIME]: (state: any, action: any) =>
    immutableSet([STEP_FOUR], action.payload, state),
  [actionTypes.SUPERVISORS_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_TWO, SUPERVISORS, LOADER_IDENTIFIER], true, state),
  [actionTypes.SUPERVISORS_REQUEST_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_TWO, SUPERVISORS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_TWO, SUPERVISORS, LIST_IDENTIFIER], action.payload)
    )(state),
  [actionTypes.SUPERVISORS_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_TWO, SUPERVISORS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_TWO, SUPERVISORS, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.SET_ADDED_SUPERVISORS]: (state: any, action: any) =>
    immutableSet([STEP_TWO, ADDED_SUPERVISORS], action.payload, state),

  [actionTypes.REVISOR_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_THREE, REVISORS, LOADER_IDENTIFIER], true, state),
  [actionTypes.REVISOR_REQUEST_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_THREE, REVISORS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_THREE, REVISORS, LIST_IDENTIFIER], action.payload)
    )(state),
  [actionTypes.REVISOR_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_THREE, REVISORS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_THREE, REVISORS, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.SET_REVISOR_SELECTED]: (state: any, action: any) =>
    immutableSet([STEP_THREE, REVISOR_SELECTED], action.payload, state),

  [actionTypes.GROUPS_PERIMETER_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_FIVE, GROUPS, LOADER_IDENTIFIER], true, state),
  [actionTypes.GROUPS_PERIMETER_REQUEST_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_FIVE, GROUPS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_FIVE, GROUPS, LIST_IDENTIFIER], action.payload)
    )(state),
  [actionTypes.GROUPS_PERIMETER_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_FIVE, GROUPS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_FIVE, GROUPS, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.SET_ADDED_GROUPS_PERIMETER]: (state: any, action: any) =>
    immutableSet([STEP_FIVE, ADDED_GROUPS], action.payload, state),

  [actionTypes.USERS_PERIMETER_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_SIX, USERS, LOADER_IDENTIFIER], true, state),
  [actionTypes.USERS_PERIMETER_REQUEST_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_SIX, USERS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_SIX, USERS, LIST_IDENTIFIER], action.payload)
    )(state),
  [actionTypes.USERS_PERIMETER_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_SIX, USERS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_SIX, USERS, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.SET_ADDED_USERS_PERIMETER]: (state: any, action: any) =>
    immutableSet([STEP_SIX, ADDED_USERS], action.payload, state),

  [actionTypes.APPLICATIONS_PERIMETER_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_SEVEN, APPLICATIONS, LOADER_IDENTIFIER], true, state),
  [actionTypes.APPLICATIONS_PERIMETER_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_SEVEN, APPLICATIONS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_SEVEN, APPLICATIONS, LIST_IDENTIFIER], action.payload)
    )(state),
  [actionTypes.APPLICATIONS_PERIMETER_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_SEVEN, APPLICATIONS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_SEVEN, APPLICATIONS, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.SET_ADDED_APPLICATIONS_PERIMETER]: (state: any, action: any) =>
    immutableSet([STEP_SEVEN, ADDED_APPLICATIONS], action.payload, state),

  [actionTypes.BR_PERIMETER_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_EIGHT, BR, LOADER_IDENTIFIER], true, state),
  [actionTypes.BR_PERIMETER_REQUEST_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_EIGHT, BR, LOADER_IDENTIFIER], false),
      immutableSet([STEP_EIGHT, BR, LIST_IDENTIFIER], action.payload)
    )(state),
  [actionTypes.BR_PERIMETER_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_EIGHT, BR, LOADER_IDENTIFIER], false),
      immutableSet([STEP_EIGHT, BR, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.SET_ADDED_BR_PERIMETER]: (state: any, action: any) =>
    immutableSet([STEP_EIGHT, ADDED_BR], action.payload, state),

  [actionTypes.ENTITLEMENTS_PERIMETER_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_NINE, ENTITLEMENTS, LOADER_IDENTIFIER], true, state),
  [actionTypes.ENTITLEMENTS_PERIMETER_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_NINE, ENTITLEMENTS, LOADER_IDENTIFIER], false),
      immutableSet(
        [STEP_NINE, ENTITLEMENTS, LIST_IDENTIFIER],
        action.payload.filter((entitlement: any) => entitlement.showOnFrontend)
      )
    )(state),
  [actionTypes.ENTITLEMENTS_PERIMETER_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_NINE, ENTITLEMENTS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_NINE, ENTITLEMENTS, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.SET_ADDED_ENTITLEMENTS_PERIMETER]: (state: any, action: any) =>
    immutableSet([STEP_NINE, ADDED_ENTITLEMENTS], action.payload, state),

  [actionTypes.TECHNICAL_USERS_PERIMETER_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_TEN, TECHNCIAL_USERS, LOADER_IDENTIFIER], true, state),
  [actionTypes.TECHNICAL_USERS_PERIMETER_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const mappedResponse: TechnicalUserDisplayedModel[] = []
    action.payload &&
      action.payload.length > 0 &&
      action.payload.forEach((tu: TechnicalUserModel) => {
        mappedResponse.push({
          _changePasswordAllowed: tu.changePasswordAllowed,
          _resetPasswordAllowed: tu.resetPasswordAllowed,
          code: tu.tuCode,
          applicationId: tu.applicationId,
          application: tu.applicationName,
          tiType: tu.tiType,
          description: tu.description,
          identitySystemId:
            IDENTITY_SYSTEM[
              tu.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
          tiCode: tu.tiCode,
          tuAccountId: tu.tuAccountId,
          _mfaRequired: tu.mfaRequired,
          _securityQuestionsRequired: tu.securityQuestionsRequired,
          _uigpOTPRequired: tu.uigpOTPRequired,
        })
      })
    return compose(
      immutableSet([STEP_TEN, TECHNCIAL_USERS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_TEN, TECHNCIAL_USERS, LIST_IDENTIFIER], mappedResponse)
    )(state)
  },
  [actionTypes.TECHNICAL_USERS_PERIMETER_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_TEN, TECHNCIAL_USERS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_TEN, TECHNCIAL_USERS, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.SET_ADDED_TECHNICAL_USERS]: (state: any, action: any) =>
    immutableSet([STEP_TEN, ADDED_TECHNCIAL_USERS], action.payload, state),

  [actionTypes.SET_TAB_SELECTED]: (state: any, action: any) =>
    immutableSet([action.tab, TAB_SELECTED_IDENTIFIER], action.payload, state),

  [actionTypes.SET_TRIGGER_CONFIRM_MODAL_CREATE_CERTIFICATION]: (
    state: any,
    action: any
  ) => immutableSet([CONFIRM_MODAL_TRIGGER], action.payload, state),

  [actionTypes.CREATE_CERTIFICATION_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.CREATE_CERTIFICATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.CREATE_CERTIFICATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.EDIT_CERTIFICATION_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.EDIT_CERTIFICATION_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.EDIT_CERTIFICATION_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.RESET_PERIMETERS_CREATE_CERTIFICATION]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_FIVE, ADDED_GROUPS], []),
      immutableSet([STEP_SIX, ADDED_USERS], []),
      immutableSet([STEP_SEVEN, ADDED_APPLICATIONS], []),
      immutableSet([STEP_EIGHT, ADDED_BR], []),
      immutableSet([STEP_NINE, ADDED_ENTITLEMENTS], [])
    )(state),

  [actionTypes.RESET_STATE_CREATE_EDIT_CERTIFICATION]: (
    state: any,
    action: any
  ) => emptyState,
}

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === '@@router/LOCATION_CHANGE' &&
    (action.payload.location.pathname === '/welcome' ||
      action.payload.location.pathname === '/admin')
  ) {
    return emptyState
  }
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}
